import React, { Component, Fragment } from 'react'
import AllProducts from '../components/AllProducts/AllProducts'
import Footer from '../components/Footer/Footer'
import PageTop from '../components/PageTop/PageTop'
import TopNavigation from '../components/TopNavigation/TopNavigation'

class AllProductPage extends Component {
     componentDidMount(){
          window.scroll(0,0)
      }
     render() {
          return (
              <Fragment>
                   <TopNavigation title="All Products" />  
                   <PageTop pagetitle="All Products" />
                   <AllProducts />
                   <Footer />
              </Fragment>
          )
     }
}

export default AllProductPage
